import Box from '@/internals/Box';

// export types
export type { BoxProps } from '@/internals/Box';

// export components
export { Box };
export default Box;
